import { useState, useRef } from "react";
import InputRange from "react-input-range";

const PirceSlider = () => {
  const [price, setPrice] = useState({
    value: { min: 0, max: 500 },
  });
  const timeoutRef = useRef(null);

  const handleOnChange = (value) => {
    setPrice({ value });

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      
      // onRangeChange(value);
    }, 300);
  };


  // 

  return (
    <div className="js-price-rangeSlider">

      <div className="d-flex justify-between mb-20">
        <div className="text-15 text-dark-1">
          <span className="js-lower mx-1">${price.value.min}</span>-
          <span className="js-upper mx-1">${price.value.max}</span>
        </div>
      </div>

      <div className="px-5">
        <InputRange
          formatLabel={(value) => ``}
          minValue={0}
          maxValue={2000}
          value={price.value}
          onChange={(value) => handleOnChange(value)}

        />
      </div>
    </div>
  );
};

export default PirceSlider;
